import { render, staticRenderFns } from "./PictogramBoqsSettings.vue?vue&type=template&id=516f76ea"
import script from "./PictogramBoqsSettings.vue?vue&type=script&lang=js"
export * from "./PictogramBoqsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports